module.exports = __webpack_public_path__ + "static/img/default.735a5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/s_tree1_seed/default.png
// module id = PpAM
// module chunks = 1